(ns core.front.transit
  (:require [clojure.string :as str]
            [cognitect.transit :as transit]))

(def +writer+ (transit/writer :json))
(def +reader+ (transit/reader :json
                              {:handlers {"BigDecimal" (transit/read-handler parse-double)}}))

(defn encode [data]
  (try (transit/write +writer+ data)
       (catch js/Error e
         (js/console.error "Cannot encode" (str data))
         (throw e))))

(defn decode [data]
  (when-not (str/blank? data)
    (transit/read +reader+ data)))
